var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantReviewQrMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6667H14.6667V4H4V14.6667ZM6.66667 6.66667H12V12H6.66667V6.66667ZM4 28H14.6667V17.3333H4V28ZM6.66667 20H12V25.3333H6.66667V20ZM17.3333 4V14.6667H28V4H17.3333ZM25.3333 12H20V6.66667H25.3333V12ZM17.3467 17.3333H20.0133V20H17.3467V17.3333ZM20.0133 20H22.68V22.6667H20.0133V20ZM17.3467 22.6667H20.0133V25.3333H17.3467V22.6667ZM22.68 22.6667H25.3467V25.3333H22.68V22.6667ZM25.3467 25.3333H28.0133V28H25.3467V25.3333ZM20.0133 25.3333H22.68V28H20.0133V25.3333ZM22.68 17.3333H25.3467V20H22.68V17.3333ZM25.3467 20H28.0133V22.6667H25.3467V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantReviewQrMark);
export default __webpack_public_path__ + "static/media/restaurant-review-qr-mark.4cefb82dcb4762ca6fd6f7959ec545b1.svg";
export { ForwardRef as ReactComponent };